import { css } from "styled-components"

export const globals = {
  white: "#fff",
  brandPrimaryDark: "#6432fa",
  brandPrimaryDarkTransparent: "rgba(100, 50, 250, 0.6)",
  brandPrimaryMedium: "#46e6e6",
  brandPrimaryLight: "#fff",
  brandPrimaryLightRGB: "255, 255, 255",
  brandPrimaryLightTransparent: "rgba(255, 255, 255, 0.6)",
  brandSecondaryDark: "#3c3c3c",
  brandSecondaryMedium: "#7c7c7c",
  brandSecondaryMediumRGB: "124, 124, 124",
  brandSecondaryLight: "#f0f0f0",
  brandSecondaryLightTransparent: "rgba(240, 240, 240, 0.5)",
  brandSecondaryLighter: "#fafafa",
  brandLinks: "#6432fa",
  brandLinksHover: "#c83cff",
  transitionTime: "250ms",
  boxShadowSmall: "0 0 5px 0 rgba(0,0,0,0.20)",
  boxShadowMedium: "0 0 6px 0 rgba(156, 156, 156, 0.5)",
  boxShadowMediumHover: "0 0 25px 0 rgba(0, 0, 0, 0.07)",
  headerHeightXs: 95,
  headerHeightSm: 95,
  headerHeightMd: 95,
  headerHeightLg: 140,
  fontWeightNormal: 400,
  fontWeightBold: 700,
  containerXs: 570,
  containerSm: 720,
  containerMd: 720,
  containerLg: 960,
  containerXl: 1260,
  spacingXs: 20,
  spacing: 30,
}

export const lightTheme = {
  ...globals,
  name: "light",
  pageBackground: globals.white,
  textColor: globals.brandSecondaryDark,
  textColorLight: globals.brandSecondaryMedium,
  inputBackground: globals.brandSecondaryLight,
  inputColor: globals.brandSecondaryDark,
  inputBorder: globals.brandSecondaryDark,
  borderColor: globals.brandSecondaryLight,
  codeBackground: globals.brandSecondaryLighter,
  codeBorder: globals.brandSecondaryLight,
}

export const darkTheme = {
  ...globals,
  name: "dark",
  pageBackground: "#111c1b",
  textColor: globals.white,
  textColorLight: "rgba(255,255,255,0.5)",
  inputBackground: globals.brandSecondaryDark,
  inputColor: globals.brandPrimaryLight,
  inputBorder: globals.brandSecondaryLight,
  borderColor: `rgba(${globals.brandPrimaryLightRGB}, 0.2)`,
  codeBackground: globals.brandSecondaryLighter,
  codeBorder: globals.brandSecondaryLight,
  brandLinks: globals.brandPrimaryMedium,
}

export const breakpoint = {
  xs: 0,
  sm: 576,
  md: 768, // tablet portrait
  lg: 992, // tablet landscape
  xl: 1200, // desktop
  xxl: 1400, // desktop large
  phoneMedium: 375,
  tablet: 768,
  tabletLandscape: 992,
  desktop: 1200,
}

export const media = {
  xs: `(min-width: ${breakpoint.xs}px)`,
  sm: `(min-width: ${breakpoint.sm}px)`,
  md: `(min-width: ${breakpoint.md}px)`,
  lg: `(min-width: ${breakpoint.lg}px)`,
  xl: `(min-width: ${breakpoint.xl}px)`,
  xxl: `(min-width: ${breakpoint.xxl}px)`,
  phoneMedium: `(min-width: ${breakpoint.phoneMedium}px)`,
  tablet: `(min-width: ${breakpoint.tablet}px)`,
  tabletLandscape: `(min-width: ${breakpoint.tabletLandscape}px)`,
  desktop: `(min-width: ${breakpoint.desktop}px)`,
  smDown: `(max-width: ${breakpoint.sm - 1}px)`,
  mdDown: `(max-width: ${breakpoint.md - 1}px)`,
  lgDown: `(max-width: ${breakpoint.lg - 1}px)`,
  xlDown: `(max-width: ${breakpoint.xl - 1}px)`,
  xxlDown: `(max-width: ${breakpoint.xxl - 1}px)`,
}

export const mixins = {
  title1: css`
    font-size: 27px;
    line-height: 34px;
    margin-bottom: 15px;

    @media ${media.tabletLandscape} {
      font-size: 32px;
      line-height: 41px;
      margin-bottom: 55px;
    }

    @media ${media.desktop} {
      font-size: 42px;
      line-height: 53px;
    }
  `,
  title2: css`
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 15px;

    @media ${media.tablet} {
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 15px;
    }

    @media ${media.tabletLandscape} {
      font-size: 48px;
      line-height: 60px;
    }
  `,
  title3: css`
    font-size: 26px;
    line-height: 33px;
    margin-bottom: 15px;

    @media ${media.tabletLandscape} {
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 20px;
    }
  `,
  title4: css`
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 15px;

    @media ${media.tabletLandscape} {
      font-size: 24px;
      line-height: 30px;
    }
  `,
  title5: css`
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 10px;

    @media ${media.tabletLandscape} {
      font-size: 20px;
      line-height: 28px;
    }
  `,
  copy: css`
    margin: 0 0 10px 0;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;

    @media ${media.tabletLandscape} {
      font-size: 20px;
      line-height: 28px;
    }
  `,
  copySmall: css`
    font-size: 12px;
    line-height: 18px;

    @media ${media.tabletLandscape} {
      font-size: 16px;
      line-height: 24px;
    }
  `,
  textLight: css`
    p,
    li {
      color: ${({ theme }) => theme.textColorLight};
    }
  `,
}
